import React from 'react'
import { enquiryInputType, strings } from '@constants'
// import { ItemWrapper, QuoteItemWrapper, QuotePickerWrapper, ScrapQuoteItemWrapper } from '../../style'
import { ItemCard } from '@base'
import { decimalSeparatedNumber } from '@utils'

const AddItemsQuote = ({ state, isScrap, editItemButtonClick }) => {
	if (state?.newEnquiry?.enquiry_items === undefined) return '-'
	return (state?.newEnquiry?.enquiry_items || [])?.map((item, index) => {
		const itemData = [
			{
				label: strings('category'),
				value: item?.category_name,
			},
			{
				label: strings('product'),
				value: item?.product_name ?? '--',
				wrap: true,
			},
			{
				label:
					item?.input_type === enquiryInputType.LENGTH
						? strings('length')
						: item?.input_type === enquiryInputType.PIECE
						? strings('pieces')
						: strings('weight_mt'),
				value:
					item?.input_type === enquiryInputType.LENGTH
						? `${item?.required_length} (${item?.required_weight / 1000 || '-'} MT)`
						: item?.input_type === enquiryInputType.PIECE
						? `${item?.required_pieces} (${item?.required_weight / 1000 || '-'} MT)`
						: decimalSeparatedNumber(item?.required_weight / 1000),
			},
			{
				label: strings('target', 'price'),
				value: item?.target_price ?? '--',
			},
			{
				label: strings('brands'),
				value: item?.brands?.join(', ') || item?.brand,
			},
			{ label: strings('grade'), value: item?.grade ?? '--' },
			{ label: strings('price_per_kg'), value: item?.price_per_kg ?? '--' },
			{
				label: strings('tc_reqd'),
				value: item?.tc_required ? strings('yes') : strings('no'),
			},
			{
				label: strings('hsn', 'code'),
				value: item?.hsn_code ?? '--',
			},
			{
				label: strings('message'),
				value: item?.message ?? '--',
				isMessage: true,
			},
		]
		return <ItemCard clickable={true} clickHandler={editItemButtonClick} data={itemData} id={item?.id} key={`enquiry-item-${index}`} />
	})
}

export default AddItemsQuote
